import { fetcherAlegriia } from "@utils/requests";
import { useMemo } from "react";
import useSWR from "swr";
import { useShallow } from "zustand/react/shallow";
import { useStore } from "../..";
import { IFoodTypeFromRestaurant } from "../../types/requests/foodTypes";
import { IRestaurant } from "../../types/requests/restaurant";
import { useUser } from "./useUser";

export const useRestaurant = () => {
  const { token, idAddress } = useStore(
    useShallow((state) => ({
      token: state.token,
      idAddress: state.idAddress,
    }))
  );
  const { restaurants } = useUser();
  const address = idAddress || restaurants?.at(0)?.addresses.at(0)?.idAddress;
  const { data: infoRestaurant, mutate } = useSWR<IRestaurant[]>(
    !!token &&
      !!address && {
        url: "/restaurant",
        auth: token,
        params: {
          idAddress: address,
        },
      },
    fetcherAlegriia
  );
  const restaurant = infoRestaurant?.at(0);
  const { data: foodTypesFromRestaurant, mutate: mutateFoodTypes } = useSWR<
    IFoodTypeFromRestaurant[]
  >(
    !!restaurant?.idRestaurant && {
      url: "/foodTypes",
      params: {
        idRestaurant: restaurant.idRestaurant,
      },
    },
    fetcherAlegriia
  );

  return useMemo(
    () => ({
      restaurant: restaurant
        ? {
            foodTypes: foodTypesFromRestaurant,
            ...restaurant,
          }
        : undefined,
      idAddress,
      mutate,
      mutateFoodTypes,
    }),
    [foodTypesFromRestaurant, idAddress, mutate, restaurant, mutateFoodTypes]
  );
};
